/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "web_services/candidate_experience/proto/web_offer.proto" (package "applied.candidate_experience", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { MarketConditions } from "./common_pb";
import { Employee } from "./user_pb";
import { Timestamp } from "../../../google/protobuf/timestamp_pb";
/**
 * The data for the web offer page that gets sent to the frontend.
 *
 * @generated from protobuf message applied.candidate_experience.WebOffer
 */
export interface WebOffer {
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferConfiguration configuration = 1;
     */
    configuration?: WebOfferConfiguration;
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferSelection selection = 2;
     */
    selection?: WebOfferSelection;
}
/**
 * Parameters of the web offer selected by the candidate.
 *
 * @generated from protobuf message applied.candidate_experience.WebOfferSelection
 */
export interface WebOfferSelection {
    /**
     * If the user has completed their selection and requested the offer letter.
     *
     * @generated from protobuf field: bool is_final = 1;
     */
    isFinal: boolean;
    /**
     * @generated from protobuf field: int64 salary_subdivisions = 2;
     */
    salarySubdivisions: bigint;
    /**
     * @generated from protobuf field: int64 sign_on_bonus_subdivisions = 3;
     */
    signOnBonusSubdivisions: bigint;
    /**
     * @generated from protobuf field: int64 equity_usd_cents = 4;
     */
    equityUsdCents: bigint;
}
/**
 * The data about the job that gets sent to the frontend.
 *
 * @generated from protobuf message applied.candidate_experience.WebOfferJobInfo
 */
export interface WebOfferJobInfo {
    /**
     * @generated from protobuf field: string job_title = 1;
     */
    jobTitle: string;
    /**
     * @generated from protobuf field: optional string ats_job_post_url = 6;
     */
    atsJobPostUrl?: string;
    /**
     * @generated from protobuf field: string team_name = 3;
     */
    teamName: string;
    /**
     * @generated from protobuf field: optional string team_page_url = 4;
     */
    teamPageUrl?: string;
}
/**
 * The data about the web offer job that gets sent from Anaheim to the backend.
 *
 * @generated from protobuf message applied.candidate_experience.WebOfferJobSyncInfo
 */
export interface WebOfferJobSyncInfo {
    /**
     * @generated from protobuf field: string job_title = 1;
     */
    jobTitle: string;
    /**
     * @generated from protobuf field: optional string ats_job_post_url = 6;
     */
    atsJobPostUrl?: string;
    /**
     * @generated from protobuf field: string team_name = 3;
     */
    teamName: string;
    /**
     * @generated from protobuf field: optional string team_page_url = 4;
     */
    teamPageUrl?: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.WebOfferCompensationInfo
 */
export interface WebOfferCompensationInfo {
    /**
     * @generated from protobuf field: string currency = 1;
     */
    currency: string;
    /**
     * @generated from protobuf field: string benefits_type = 2;
     */
    benefitsType: string;
    /**
     * @generated from protobuf field: int64 base_salary_subdivisions = 3;
     */
    baseSalarySubdivisions: bigint;
    /**
     * @generated from protobuf field: float salary_threshold_percentage = 4;
     */
    salaryThresholdPercentage: number;
    /**
     * @generated from protobuf field: int64 max_sign_on_bonus_subdivisions = 5;
     */
    maxSignOnBonusSubdivisions: bigint;
    /**
     * @generated from protobuf field: int64 base_equity_usd_cents = 6;
     */
    baseEquityUsdCents: bigint;
    /**
     * @generated from protobuf field: float salary_equity_ratio = 7;
     */
    salaryEquityRatio: number;
    /**
     * @generated from protobuf field: float sign_on_bonus_equity_ratio = 8;
     */
    signOnBonusEquityRatio: number;
    /**
     * @generated from protobuf field: int64 relocation_bonus_subdivisions = 9;
     */
    relocationBonusSubdivisions: bigint;
    /**
     * @generated from protobuf field: string annual_bonus_type = 10;
     */
    annualBonusType: string;
    /**
     * @generated from protobuf field: int64 annual_bonus_value = 11;
     */
    annualBonusValue: bigint;
    /**
     * @generated from protobuf field: bool is_salary_static = 12;
     */
    isSalaryStatic: boolean;
    /**
     * @generated from protobuf field: bool is_sign_on_bonus_static = 13;
     */
    isSignOnBonusStatic: boolean;
}
/**
 * The data about the web offer configuration that gets sent to the frontend.
 *
 * @generated from protobuf message applied.candidate_experience.WebOfferConfiguration
 */
export interface WebOfferConfiguration {
    /**
     * @generated from protobuf field: bool is_hidden = 8;
     */
    isHidden: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deadline = 9;
     */
    deadline?: Timestamp;
    /**
     * @generated from protobuf field: bool show_50_hour_work_week_video = 10;
     */
    show50HourWorkWeekVideo: boolean;
    /**
     * @generated from protobuf field: applied.candidate_experience.Employee manager = 2;
     */
    manager?: Employee;
    /**
     * @generated from protobuf field: repeated applied.candidate_experience.Employee team_members = 3;
     */
    teamMembers: Employee[];
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferJobInfo job_info = 4;
     */
    jobInfo?: WebOfferJobInfo;
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferCompensationInfo compensation_info = 6;
     */
    compensationInfo?: WebOfferCompensationInfo;
    /**
     * @generated from protobuf field: applied.candidate_experience.MarketConditions market_conditions = 7;
     */
    marketConditions?: MarketConditions;
}
/**
 * The data about the web offer configuration that gets sent from Anaheim to the backend.
 *
 * @generated from protobuf message applied.candidate_experience.WebOfferConfigurationSyncRequest
 */
export interface WebOfferConfigurationSyncRequest {
    /**
     * @generated from protobuf field: string application_id = 11;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: bool is_hidden = 8;
     */
    isHidden: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deadline = 9;
     */
    deadline?: Timestamp;
    /**
     * @generated from protobuf field: bool show_50_hour_work_week_video = 10;
     */
    show50HourWorkWeekVideo: boolean;
    /**
     * @generated from protobuf field: string manager_anaheim_uuid = 2;
     */
    managerAnaheimUuid: string;
    /**
     * @generated from protobuf field: repeated string team_members_anaheim_uuids = 3;
     */
    teamMembersAnaheimUuids: string[];
    /**
     * Used to send notification to the recruiter post-acceptance, not used on the page itself
     *
     * @generated from protobuf field: string recruiter_anaheim_uuid = 5;
     */
    recruiterAnaheimUuid: string;
    /**
     * @generated from protobuf field: string recruiting_manager_anaheim_uuid = 12;
     */
    recruitingManagerAnaheimUuid: string;
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferJobSyncInfo job_info = 4;
     */
    jobInfo?: WebOfferJobSyncInfo;
    /**
     * @generated from protobuf field: applied.candidate_experience.WebOfferCompensationInfo compensation_info = 6;
     */
    compensationInfo?: WebOfferCompensationInfo;
    /**
     * @generated from protobuf field: applied.candidate_experience.MarketConditions market_conditions = 7;
     */
    marketConditions?: MarketConditions;
}
/**
 * The response for an icon from the web offer icons folder.
 *
 * @generated from protobuf message applied.candidate_experience.IconResponse
 */
export interface IconResponse {
    /**
     * @generated from protobuf field: string icon_url = 1;
     */
    iconUrl: string;
}
/**
 * Request to update salary subdivisions in an offer selection.
 *
 * @generated from protobuf message applied.candidate_experience.UpdateSalaryRequest
 */
export interface UpdateSalaryRequest {
    /**
     * @generated from protobuf field: int64 salary_subdivisions = 1;
     */
    salarySubdivisions: bigint;
}
/**
 * Request to update sign-on bonus subdivisions in an offer selection.
 *
 * @generated from protobuf message applied.candidate_experience.UpdateSignOnBonusRequest
 */
export interface UpdateSignOnBonusRequest {
    /**
     * @generated from protobuf field: int64 sign_on_bonus_subdivisions = 1;
     */
    signOnBonusSubdivisions: bigint;
}
/**
 * @generated from protobuf message applied.candidate_experience.EmployeeOfferInfo
 */
export interface EmployeeOfferInfo {
    /**
     * @generated from protobuf field: string candidate_email = 1;
     */
    candidateEmail: string;
    /**
     * @generated from protobuf field: string candidate_first_name = 2;
     */
    candidateFirstName: string;
    /**
     * @generated from protobuf field: string candidate_last_name = 3;
     */
    candidateLastName: string;
}
/**
 * @generated from protobuf message applied.candidate_experience.EmployeeOffersResponse
 */
export interface EmployeeOffersResponse {
    /**
     * @generated from protobuf field: repeated applied.candidate_experience.EmployeeOfferInfo offers = 1;
     */
    offers: EmployeeOfferInfo[];
}
/**
 * @generated from protobuf message applied.candidate_experience.EmployeeInfoResponse
 */
export interface EmployeeInfoResponse {
    /**
     * @generated from protobuf field: string first_name = 1;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 2;
     */
    lastName: string;
    /**
     * @generated from protobuf field: repeated string employee_scopes = 3;
     */
    employeeScopes: string[];
}
/**
 * Response containing the current selection values.
 *
 * @generated from protobuf message applied.candidate_experience.GetCurrentSelectionResponse
 */
export interface GetCurrentSelectionResponse {
    /**
     * @generated from protobuf field: int64 salary_subdivisions = 1;
     */
    salarySubdivisions: bigint;
    /**
     * @generated from protobuf field: int64 sign_on_bonus_subdivisions = 2;
     */
    signOnBonusSubdivisions: bigint;
    /**
     * @generated from protobuf field: int64 equity_usd_cents = 3;
     */
    equityUsdCents: bigint;
}
/**
 * Response for checking whether a web offer configuration exists for an application.
 *
 * @generated from protobuf message applied.candidate_experience.CheckWebOfferExistsResponse
 */
export interface CheckWebOfferExistsResponse {
    /**
     * @generated from protobuf field: bool exists = 1;
     */
    exists: boolean;
}
/**
 * Response for checking whether the latest offer selection for an application
 * has been submitted (marked final).
 *
 * @generated from protobuf message applied.candidate_experience.CheckOfferSubmittedResponse
 */
export interface CheckOfferSubmittedResponse {
    /**
     * @generated from protobuf field: bool is_submitted = 1;
     */
    isSubmitted: boolean;
}
/**
 * Request to unsubmit (un-finalize) the latest offer selection for an application.
 *
 * @generated from protobuf message applied.candidate_experience.UnsubmitOfferRequest
 */
export interface UnsubmitOfferRequest {
    /**
     * @generated from protobuf field: string application_id = 1;
     */
    applicationId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class WebOffer$Type extends MessageType<WebOffer> {
    constructor() {
        super("applied.candidate_experience.WebOffer", [
            { no: 1, name: "configuration", kind: "message", T: () => WebOfferConfiguration },
            { no: 2, name: "selection", kind: "message", T: () => WebOfferSelection }
        ]);
    }
    create(value?: PartialMessage<WebOffer>): WebOffer {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WebOffer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOffer): WebOffer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* applied.candidate_experience.WebOfferConfiguration configuration */ 1:
                    message.configuration = WebOfferConfiguration.internalBinaryRead(reader, reader.uint32(), options, message.configuration);
                    break;
                case /* applied.candidate_experience.WebOfferSelection selection */ 2:
                    message.selection = WebOfferSelection.internalBinaryRead(reader, reader.uint32(), options, message.selection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOffer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* applied.candidate_experience.WebOfferConfiguration configuration = 1; */
        if (message.configuration)
            WebOfferConfiguration.internalBinaryWrite(message.configuration, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.WebOfferSelection selection = 2; */
        if (message.selection)
            WebOfferSelection.internalBinaryWrite(message.selection, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOffer
 */
export const WebOffer = new WebOffer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferSelection$Type extends MessageType<WebOfferSelection> {
    constructor() {
        super("applied.candidate_experience.WebOfferSelection", [
            { no: 1, name: "is_final", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "salary_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "sign_on_bonus_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "equity_usd_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<WebOfferSelection>): WebOfferSelection {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isFinal = false;
        message.salarySubdivisions = 0n;
        message.signOnBonusSubdivisions = 0n;
        message.equityUsdCents = 0n;
        if (value !== undefined)
            reflectionMergePartial<WebOfferSelection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferSelection): WebOfferSelection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_final */ 1:
                    message.isFinal = reader.bool();
                    break;
                case /* int64 salary_subdivisions */ 2:
                    message.salarySubdivisions = reader.int64().toBigInt();
                    break;
                case /* int64 sign_on_bonus_subdivisions */ 3:
                    message.signOnBonusSubdivisions = reader.int64().toBigInt();
                    break;
                case /* int64 equity_usd_cents */ 4:
                    message.equityUsdCents = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferSelection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_final = 1; */
        if (message.isFinal !== false)
            writer.tag(1, WireType.Varint).bool(message.isFinal);
        /* int64 salary_subdivisions = 2; */
        if (message.salarySubdivisions !== 0n)
            writer.tag(2, WireType.Varint).int64(message.salarySubdivisions);
        /* int64 sign_on_bonus_subdivisions = 3; */
        if (message.signOnBonusSubdivisions !== 0n)
            writer.tag(3, WireType.Varint).int64(message.signOnBonusSubdivisions);
        /* int64 equity_usd_cents = 4; */
        if (message.equityUsdCents !== 0n)
            writer.tag(4, WireType.Varint).int64(message.equityUsdCents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferSelection
 */
export const WebOfferSelection = new WebOfferSelection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferJobInfo$Type extends MessageType<WebOfferJobInfo> {
    constructor() {
        super("applied.candidate_experience.WebOfferJobInfo", [
            { no: 1, name: "job_title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "ats_job_post_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "team_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "team_page_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebOfferJobInfo>): WebOfferJobInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.jobTitle = "";
        message.teamName = "";
        if (value !== undefined)
            reflectionMergePartial<WebOfferJobInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferJobInfo): WebOfferJobInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string job_title */ 1:
                    message.jobTitle = reader.string();
                    break;
                case /* optional string ats_job_post_url */ 6:
                    message.atsJobPostUrl = reader.string();
                    break;
                case /* string team_name */ 3:
                    message.teamName = reader.string();
                    break;
                case /* optional string team_page_url */ 4:
                    message.teamPageUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferJobInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string job_title = 1; */
        if (message.jobTitle !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jobTitle);
        /* optional string ats_job_post_url = 6; */
        if (message.atsJobPostUrl !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.atsJobPostUrl);
        /* string team_name = 3; */
        if (message.teamName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.teamName);
        /* optional string team_page_url = 4; */
        if (message.teamPageUrl !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.teamPageUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferJobInfo
 */
export const WebOfferJobInfo = new WebOfferJobInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferJobSyncInfo$Type extends MessageType<WebOfferJobSyncInfo> {
    constructor() {
        super("applied.candidate_experience.WebOfferJobSyncInfo", [
            { no: 1, name: "job_title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "ats_job_post_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "team_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "team_page_url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WebOfferJobSyncInfo>): WebOfferJobSyncInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.jobTitle = "";
        message.teamName = "";
        if (value !== undefined)
            reflectionMergePartial<WebOfferJobSyncInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferJobSyncInfo): WebOfferJobSyncInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string job_title */ 1:
                    message.jobTitle = reader.string();
                    break;
                case /* optional string ats_job_post_url */ 6:
                    message.atsJobPostUrl = reader.string();
                    break;
                case /* string team_name */ 3:
                    message.teamName = reader.string();
                    break;
                case /* optional string team_page_url */ 4:
                    message.teamPageUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferJobSyncInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string job_title = 1; */
        if (message.jobTitle !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jobTitle);
        /* optional string ats_job_post_url = 6; */
        if (message.atsJobPostUrl !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.atsJobPostUrl);
        /* string team_name = 3; */
        if (message.teamName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.teamName);
        /* optional string team_page_url = 4; */
        if (message.teamPageUrl !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.teamPageUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferJobSyncInfo
 */
export const WebOfferJobSyncInfo = new WebOfferJobSyncInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferCompensationInfo$Type extends MessageType<WebOfferCompensationInfo> {
    constructor() {
        super("applied.candidate_experience.WebOfferCompensationInfo", [
            { no: 1, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "benefits_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "base_salary_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "salary_threshold_percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "max_sign_on_bonus_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "base_equity_usd_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "salary_equity_ratio", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "sign_on_bonus_equity_ratio", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "relocation_bonus_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "annual_bonus_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "annual_bonus_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 12, name: "is_salary_static", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "is_sign_on_bonus_static", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<WebOfferCompensationInfo>): WebOfferCompensationInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currency = "";
        message.benefitsType = "";
        message.baseSalarySubdivisions = 0n;
        message.salaryThresholdPercentage = 0;
        message.maxSignOnBonusSubdivisions = 0n;
        message.baseEquityUsdCents = 0n;
        message.salaryEquityRatio = 0;
        message.signOnBonusEquityRatio = 0;
        message.relocationBonusSubdivisions = 0n;
        message.annualBonusType = "";
        message.annualBonusValue = 0n;
        message.isSalaryStatic = false;
        message.isSignOnBonusStatic = false;
        if (value !== undefined)
            reflectionMergePartial<WebOfferCompensationInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferCompensationInfo): WebOfferCompensationInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string currency */ 1:
                    message.currency = reader.string();
                    break;
                case /* string benefits_type */ 2:
                    message.benefitsType = reader.string();
                    break;
                case /* int64 base_salary_subdivisions */ 3:
                    message.baseSalarySubdivisions = reader.int64().toBigInt();
                    break;
                case /* float salary_threshold_percentage */ 4:
                    message.salaryThresholdPercentage = reader.float();
                    break;
                case /* int64 max_sign_on_bonus_subdivisions */ 5:
                    message.maxSignOnBonusSubdivisions = reader.int64().toBigInt();
                    break;
                case /* int64 base_equity_usd_cents */ 6:
                    message.baseEquityUsdCents = reader.int64().toBigInt();
                    break;
                case /* float salary_equity_ratio */ 7:
                    message.salaryEquityRatio = reader.float();
                    break;
                case /* float sign_on_bonus_equity_ratio */ 8:
                    message.signOnBonusEquityRatio = reader.float();
                    break;
                case /* int64 relocation_bonus_subdivisions */ 9:
                    message.relocationBonusSubdivisions = reader.int64().toBigInt();
                    break;
                case /* string annual_bonus_type */ 10:
                    message.annualBonusType = reader.string();
                    break;
                case /* int64 annual_bonus_value */ 11:
                    message.annualBonusValue = reader.int64().toBigInt();
                    break;
                case /* bool is_salary_static */ 12:
                    message.isSalaryStatic = reader.bool();
                    break;
                case /* bool is_sign_on_bonus_static */ 13:
                    message.isSignOnBonusStatic = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferCompensationInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string currency = 1; */
        if (message.currency !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.currency);
        /* string benefits_type = 2; */
        if (message.benefitsType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.benefitsType);
        /* int64 base_salary_subdivisions = 3; */
        if (message.baseSalarySubdivisions !== 0n)
            writer.tag(3, WireType.Varint).int64(message.baseSalarySubdivisions);
        /* float salary_threshold_percentage = 4; */
        if (message.salaryThresholdPercentage !== 0)
            writer.tag(4, WireType.Bit32).float(message.salaryThresholdPercentage);
        /* int64 max_sign_on_bonus_subdivisions = 5; */
        if (message.maxSignOnBonusSubdivisions !== 0n)
            writer.tag(5, WireType.Varint).int64(message.maxSignOnBonusSubdivisions);
        /* int64 base_equity_usd_cents = 6; */
        if (message.baseEquityUsdCents !== 0n)
            writer.tag(6, WireType.Varint).int64(message.baseEquityUsdCents);
        /* float salary_equity_ratio = 7; */
        if (message.salaryEquityRatio !== 0)
            writer.tag(7, WireType.Bit32).float(message.salaryEquityRatio);
        /* float sign_on_bonus_equity_ratio = 8; */
        if (message.signOnBonusEquityRatio !== 0)
            writer.tag(8, WireType.Bit32).float(message.signOnBonusEquityRatio);
        /* int64 relocation_bonus_subdivisions = 9; */
        if (message.relocationBonusSubdivisions !== 0n)
            writer.tag(9, WireType.Varint).int64(message.relocationBonusSubdivisions);
        /* string annual_bonus_type = 10; */
        if (message.annualBonusType !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.annualBonusType);
        /* int64 annual_bonus_value = 11; */
        if (message.annualBonusValue !== 0n)
            writer.tag(11, WireType.Varint).int64(message.annualBonusValue);
        /* bool is_salary_static = 12; */
        if (message.isSalaryStatic !== false)
            writer.tag(12, WireType.Varint).bool(message.isSalaryStatic);
        /* bool is_sign_on_bonus_static = 13; */
        if (message.isSignOnBonusStatic !== false)
            writer.tag(13, WireType.Varint).bool(message.isSignOnBonusStatic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferCompensationInfo
 */
export const WebOfferCompensationInfo = new WebOfferCompensationInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferConfiguration$Type extends MessageType<WebOfferConfiguration> {
    constructor() {
        super("applied.candidate_experience.WebOfferConfiguration", [
            { no: 8, name: "is_hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "deadline", kind: "message", T: () => Timestamp },
            { no: 10, name: "show_50_hour_work_week_video", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "manager", kind: "message", T: () => Employee },
            { no: 3, name: "team_members", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Employee },
            { no: 4, name: "job_info", kind: "message", T: () => WebOfferJobInfo },
            { no: 6, name: "compensation_info", kind: "message", T: () => WebOfferCompensationInfo },
            { no: 7, name: "market_conditions", kind: "message", T: () => MarketConditions }
        ]);
    }
    create(value?: PartialMessage<WebOfferConfiguration>): WebOfferConfiguration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isHidden = false;
        message.show50HourWorkWeekVideo = false;
        message.teamMembers = [];
        if (value !== undefined)
            reflectionMergePartial<WebOfferConfiguration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferConfiguration): WebOfferConfiguration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_hidden */ 8:
                    message.isHidden = reader.bool();
                    break;
                case /* google.protobuf.Timestamp deadline */ 9:
                    message.deadline = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deadline);
                    break;
                case /* bool show_50_hour_work_week_video */ 10:
                    message.show50HourWorkWeekVideo = reader.bool();
                    break;
                case /* applied.candidate_experience.Employee manager */ 2:
                    message.manager = Employee.internalBinaryRead(reader, reader.uint32(), options, message.manager);
                    break;
                case /* repeated applied.candidate_experience.Employee team_members */ 3:
                    message.teamMembers.push(Employee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* applied.candidate_experience.WebOfferJobInfo job_info */ 4:
                    message.jobInfo = WebOfferJobInfo.internalBinaryRead(reader, reader.uint32(), options, message.jobInfo);
                    break;
                case /* applied.candidate_experience.WebOfferCompensationInfo compensation_info */ 6:
                    message.compensationInfo = WebOfferCompensationInfo.internalBinaryRead(reader, reader.uint32(), options, message.compensationInfo);
                    break;
                case /* applied.candidate_experience.MarketConditions market_conditions */ 7:
                    message.marketConditions = MarketConditions.internalBinaryRead(reader, reader.uint32(), options, message.marketConditions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferConfiguration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_hidden = 8; */
        if (message.isHidden !== false)
            writer.tag(8, WireType.Varint).bool(message.isHidden);
        /* google.protobuf.Timestamp deadline = 9; */
        if (message.deadline)
            Timestamp.internalBinaryWrite(message.deadline, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool show_50_hour_work_week_video = 10; */
        if (message.show50HourWorkWeekVideo !== false)
            writer.tag(10, WireType.Varint).bool(message.show50HourWorkWeekVideo);
        /* applied.candidate_experience.Employee manager = 2; */
        if (message.manager)
            Employee.internalBinaryWrite(message.manager, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated applied.candidate_experience.Employee team_members = 3; */
        for (let i = 0; i < message.teamMembers.length; i++)
            Employee.internalBinaryWrite(message.teamMembers[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.WebOfferJobInfo job_info = 4; */
        if (message.jobInfo)
            WebOfferJobInfo.internalBinaryWrite(message.jobInfo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.WebOfferCompensationInfo compensation_info = 6; */
        if (message.compensationInfo)
            WebOfferCompensationInfo.internalBinaryWrite(message.compensationInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.MarketConditions market_conditions = 7; */
        if (message.marketConditions)
            MarketConditions.internalBinaryWrite(message.marketConditions, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferConfiguration
 */
export const WebOfferConfiguration = new WebOfferConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebOfferConfigurationSyncRequest$Type extends MessageType<WebOfferConfigurationSyncRequest> {
    constructor() {
        super("applied.candidate_experience.WebOfferConfigurationSyncRequest", [
            { no: 11, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "deadline", kind: "message", T: () => Timestamp },
            { no: 10, name: "show_50_hour_work_week_video", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "manager_anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "team_members_anaheim_uuids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "recruiter_anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "recruiting_manager_anaheim_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "job_info", kind: "message", T: () => WebOfferJobSyncInfo },
            { no: 6, name: "compensation_info", kind: "message", T: () => WebOfferCompensationInfo },
            { no: 7, name: "market_conditions", kind: "message", T: () => MarketConditions }
        ]);
    }
    create(value?: PartialMessage<WebOfferConfigurationSyncRequest>): WebOfferConfigurationSyncRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.applicationId = "";
        message.isHidden = false;
        message.show50HourWorkWeekVideo = false;
        message.managerAnaheimUuid = "";
        message.teamMembersAnaheimUuids = [];
        message.recruiterAnaheimUuid = "";
        message.recruitingManagerAnaheimUuid = "";
        if (value !== undefined)
            reflectionMergePartial<WebOfferConfigurationSyncRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WebOfferConfigurationSyncRequest): WebOfferConfigurationSyncRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string application_id */ 11:
                    message.applicationId = reader.string();
                    break;
                case /* bool is_hidden */ 8:
                    message.isHidden = reader.bool();
                    break;
                case /* google.protobuf.Timestamp deadline */ 9:
                    message.deadline = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deadline);
                    break;
                case /* bool show_50_hour_work_week_video */ 10:
                    message.show50HourWorkWeekVideo = reader.bool();
                    break;
                case /* string manager_anaheim_uuid */ 2:
                    message.managerAnaheimUuid = reader.string();
                    break;
                case /* repeated string team_members_anaheim_uuids */ 3:
                    message.teamMembersAnaheimUuids.push(reader.string());
                    break;
                case /* string recruiter_anaheim_uuid */ 5:
                    message.recruiterAnaheimUuid = reader.string();
                    break;
                case /* string recruiting_manager_anaheim_uuid */ 12:
                    message.recruitingManagerAnaheimUuid = reader.string();
                    break;
                case /* applied.candidate_experience.WebOfferJobSyncInfo job_info */ 4:
                    message.jobInfo = WebOfferJobSyncInfo.internalBinaryRead(reader, reader.uint32(), options, message.jobInfo);
                    break;
                case /* applied.candidate_experience.WebOfferCompensationInfo compensation_info */ 6:
                    message.compensationInfo = WebOfferCompensationInfo.internalBinaryRead(reader, reader.uint32(), options, message.compensationInfo);
                    break;
                case /* applied.candidate_experience.MarketConditions market_conditions */ 7:
                    message.marketConditions = MarketConditions.internalBinaryRead(reader, reader.uint32(), options, message.marketConditions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WebOfferConfigurationSyncRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string application_id = 11; */
        if (message.applicationId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.applicationId);
        /* bool is_hidden = 8; */
        if (message.isHidden !== false)
            writer.tag(8, WireType.Varint).bool(message.isHidden);
        /* google.protobuf.Timestamp deadline = 9; */
        if (message.deadline)
            Timestamp.internalBinaryWrite(message.deadline, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool show_50_hour_work_week_video = 10; */
        if (message.show50HourWorkWeekVideo !== false)
            writer.tag(10, WireType.Varint).bool(message.show50HourWorkWeekVideo);
        /* string manager_anaheim_uuid = 2; */
        if (message.managerAnaheimUuid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.managerAnaheimUuid);
        /* repeated string team_members_anaheim_uuids = 3; */
        for (let i = 0; i < message.teamMembersAnaheimUuids.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.teamMembersAnaheimUuids[i]);
        /* string recruiter_anaheim_uuid = 5; */
        if (message.recruiterAnaheimUuid !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.recruiterAnaheimUuid);
        /* string recruiting_manager_anaheim_uuid = 12; */
        if (message.recruitingManagerAnaheimUuid !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.recruitingManagerAnaheimUuid);
        /* applied.candidate_experience.WebOfferJobSyncInfo job_info = 4; */
        if (message.jobInfo)
            WebOfferJobSyncInfo.internalBinaryWrite(message.jobInfo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.WebOfferCompensationInfo compensation_info = 6; */
        if (message.compensationInfo)
            WebOfferCompensationInfo.internalBinaryWrite(message.compensationInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* applied.candidate_experience.MarketConditions market_conditions = 7; */
        if (message.marketConditions)
            MarketConditions.internalBinaryWrite(message.marketConditions, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.WebOfferConfigurationSyncRequest
 */
export const WebOfferConfigurationSyncRequest = new WebOfferConfigurationSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IconResponse$Type extends MessageType<IconResponse> {
    constructor() {
        super("applied.candidate_experience.IconResponse", [
            { no: 1, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IconResponse>): IconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.iconUrl = "";
        if (value !== undefined)
            reflectionMergePartial<IconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IconResponse): IconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string icon_url */ 1:
                    message.iconUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string icon_url = 1; */
        if (message.iconUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.iconUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.IconResponse
 */
export const IconResponse = new IconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSalaryRequest$Type extends MessageType<UpdateSalaryRequest> {
    constructor() {
        super("applied.candidate_experience.UpdateSalaryRequest", [
            { no: 1, name: "salary_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateSalaryRequest>): UpdateSalaryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salarySubdivisions = 0n;
        if (value !== undefined)
            reflectionMergePartial<UpdateSalaryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSalaryRequest): UpdateSalaryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 salary_subdivisions */ 1:
                    message.salarySubdivisions = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSalaryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 salary_subdivisions = 1; */
        if (message.salarySubdivisions !== 0n)
            writer.tag(1, WireType.Varint).int64(message.salarySubdivisions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.UpdateSalaryRequest
 */
export const UpdateSalaryRequest = new UpdateSalaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSignOnBonusRequest$Type extends MessageType<UpdateSignOnBonusRequest> {
    constructor() {
        super("applied.candidate_experience.UpdateSignOnBonusRequest", [
            { no: 1, name: "sign_on_bonus_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateSignOnBonusRequest>): UpdateSignOnBonusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.signOnBonusSubdivisions = 0n;
        if (value !== undefined)
            reflectionMergePartial<UpdateSignOnBonusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSignOnBonusRequest): UpdateSignOnBonusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 sign_on_bonus_subdivisions */ 1:
                    message.signOnBonusSubdivisions = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSignOnBonusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 sign_on_bonus_subdivisions = 1; */
        if (message.signOnBonusSubdivisions !== 0n)
            writer.tag(1, WireType.Varint).int64(message.signOnBonusSubdivisions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.UpdateSignOnBonusRequest
 */
export const UpdateSignOnBonusRequest = new UpdateSignOnBonusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeOfferInfo$Type extends MessageType<EmployeeOfferInfo> {
    constructor() {
        super("applied.candidate_experience.EmployeeOfferInfo", [
            { no: 1, name: "candidate_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "candidate_first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "candidate_last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeOfferInfo>): EmployeeOfferInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.candidateEmail = "";
        message.candidateFirstName = "";
        message.candidateLastName = "";
        if (value !== undefined)
            reflectionMergePartial<EmployeeOfferInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeOfferInfo): EmployeeOfferInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string candidate_email */ 1:
                    message.candidateEmail = reader.string();
                    break;
                case /* string candidate_first_name */ 2:
                    message.candidateFirstName = reader.string();
                    break;
                case /* string candidate_last_name */ 3:
                    message.candidateLastName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeOfferInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string candidate_email = 1; */
        if (message.candidateEmail !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.candidateEmail);
        /* string candidate_first_name = 2; */
        if (message.candidateFirstName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.candidateFirstName);
        /* string candidate_last_name = 3; */
        if (message.candidateLastName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.candidateLastName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeOfferInfo
 */
export const EmployeeOfferInfo = new EmployeeOfferInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeOffersResponse$Type extends MessageType<EmployeeOffersResponse> {
    constructor() {
        super("applied.candidate_experience.EmployeeOffersResponse", [
            { no: 1, name: "offers", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => EmployeeOfferInfo }
        ]);
    }
    create(value?: PartialMessage<EmployeeOffersResponse>): EmployeeOffersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offers = [];
        if (value !== undefined)
            reflectionMergePartial<EmployeeOffersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeOffersResponse): EmployeeOffersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated applied.candidate_experience.EmployeeOfferInfo offers */ 1:
                    message.offers.push(EmployeeOfferInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeOffersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated applied.candidate_experience.EmployeeOfferInfo offers = 1; */
        for (let i = 0; i < message.offers.length; i++)
            EmployeeOfferInfo.internalBinaryWrite(message.offers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeOffersResponse
 */
export const EmployeeOffersResponse = new EmployeeOffersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeInfoResponse$Type extends MessageType<EmployeeInfoResponse> {
    constructor() {
        super("applied.candidate_experience.EmployeeInfoResponse", [
            { no: 1, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "employee_scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmployeeInfoResponse>): EmployeeInfoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        message.employeeScopes = [];
        if (value !== undefined)
            reflectionMergePartial<EmployeeInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmployeeInfoResponse): EmployeeInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string first_name */ 1:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 2:
                    message.lastName = reader.string();
                    break;
                case /* repeated string employee_scopes */ 3:
                    message.employeeScopes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmployeeInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string first_name = 1; */
        if (message.firstName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 2; */
        if (message.lastName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.lastName);
        /* repeated string employee_scopes = 3; */
        for (let i = 0; i < message.employeeScopes.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.employeeScopes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.EmployeeInfoResponse
 */
export const EmployeeInfoResponse = new EmployeeInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCurrentSelectionResponse$Type extends MessageType<GetCurrentSelectionResponse> {
    constructor() {
        super("applied.candidate_experience.GetCurrentSelectionResponse", [
            { no: 1, name: "salary_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "sign_on_bonus_subdivisions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "equity_usd_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<GetCurrentSelectionResponse>): GetCurrentSelectionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salarySubdivisions = 0n;
        message.signOnBonusSubdivisions = 0n;
        message.equityUsdCents = 0n;
        if (value !== undefined)
            reflectionMergePartial<GetCurrentSelectionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCurrentSelectionResponse): GetCurrentSelectionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 salary_subdivisions */ 1:
                    message.salarySubdivisions = reader.int64().toBigInt();
                    break;
                case /* int64 sign_on_bonus_subdivisions */ 2:
                    message.signOnBonusSubdivisions = reader.int64().toBigInt();
                    break;
                case /* int64 equity_usd_cents */ 3:
                    message.equityUsdCents = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCurrentSelectionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 salary_subdivisions = 1; */
        if (message.salarySubdivisions !== 0n)
            writer.tag(1, WireType.Varint).int64(message.salarySubdivisions);
        /* int64 sign_on_bonus_subdivisions = 2; */
        if (message.signOnBonusSubdivisions !== 0n)
            writer.tag(2, WireType.Varint).int64(message.signOnBonusSubdivisions);
        /* int64 equity_usd_cents = 3; */
        if (message.equityUsdCents !== 0n)
            writer.tag(3, WireType.Varint).int64(message.equityUsdCents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.GetCurrentSelectionResponse
 */
export const GetCurrentSelectionResponse = new GetCurrentSelectionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckWebOfferExistsResponse$Type extends MessageType<CheckWebOfferExistsResponse> {
    constructor() {
        super("applied.candidate_experience.CheckWebOfferExistsResponse", [
            { no: 1, name: "exists", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckWebOfferExistsResponse>): CheckWebOfferExistsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exists = false;
        if (value !== undefined)
            reflectionMergePartial<CheckWebOfferExistsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckWebOfferExistsResponse): CheckWebOfferExistsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exists */ 1:
                    message.exists = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckWebOfferExistsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exists = 1; */
        if (message.exists !== false)
            writer.tag(1, WireType.Varint).bool(message.exists);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CheckWebOfferExistsResponse
 */
export const CheckWebOfferExistsResponse = new CheckWebOfferExistsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckOfferSubmittedResponse$Type extends MessageType<CheckOfferSubmittedResponse> {
    constructor() {
        super("applied.candidate_experience.CheckOfferSubmittedResponse", [
            { no: 1, name: "is_submitted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckOfferSubmittedResponse>): CheckOfferSubmittedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSubmitted = false;
        if (value !== undefined)
            reflectionMergePartial<CheckOfferSubmittedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckOfferSubmittedResponse): CheckOfferSubmittedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_submitted */ 1:
                    message.isSubmitted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckOfferSubmittedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_submitted = 1; */
        if (message.isSubmitted !== false)
            writer.tag(1, WireType.Varint).bool(message.isSubmitted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.CheckOfferSubmittedResponse
 */
export const CheckOfferSubmittedResponse = new CheckOfferSubmittedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnsubmitOfferRequest$Type extends MessageType<UnsubmitOfferRequest> {
    constructor() {
        super("applied.candidate_experience.UnsubmitOfferRequest", [
            { no: 1, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UnsubmitOfferRequest>): UnsubmitOfferRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.applicationId = "";
        if (value !== undefined)
            reflectionMergePartial<UnsubmitOfferRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnsubmitOfferRequest): UnsubmitOfferRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string application_id */ 1:
                    message.applicationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnsubmitOfferRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string application_id = 1; */
        if (message.applicationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.applicationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.UnsubmitOfferRequest
 */
export const UnsubmitOfferRequest = new UnsubmitOfferRequest$Type();
